import { DEFAULT_S3_PUB_LOCATION, FALSE, PUB_LOCATION, TRUE } from 'src/constants';
import { getNamespaceName } from 'src/services/objects/namespaces';
import { unAuthenticatedUser } from './storage';
import { LoanProductFinder } from 'src/features/NoAuth/LoanProductFinder';
import { concat, equals, find, head, pathOr, propEq } from 'ramda';
import { getSubProduct } from 'src/features/Advisors/Applications/SummaryMortgage/commonContext';
import isNilOrEmpty from './isNilOrEmpty';
import SiteSettings from 'src/siteSetting';
import { isEmptyOrNil, isNotEmpty, returnIsNotEmptyOrTrue } from './hasValue';
import { filter } from 'ramda';

const s3Pub = () => {
  return `${DEFAULT_S3_PUB_LOCATION}/${getNamespaceName()}`;
};


const filterFooterLinks = ( policyConditions: any) => {

  return filter((condition: any) => {
    return pathOr(true, ["should_show"],condition)
  }, policyConditions)
}


const getPolicyConditions = (products: any, productType: any) => {
  if (isNilOrEmpty(productType)) {
    const policyConditions = pathOr([], ['policy_conditions'], head(pathOr([], ['subproducts'], head(products))));
    const tenantPolicyConditions = pathOr([], ['tenant_policy_conditions'], head(pathOr([], ['subproducts'], head(products))));
    const policyLinks = isNotEmpty(policyConditions) ? policyConditions : tenantPolicyConditions
    return {
      policyLinks: filterFooterLinks(policyLinks),
      tenantPolicy: isNotEmpty(filterFooterLinks(tenantPolicyConditions)),
      allTenantPolicy: tenantPolicyConditions,
    }
  }
  const policyConditions = pathOr([], ['policy_conditions'], find(propEq('name', productType), getSubProduct(products)));
  const tenantPolicyConditions = pathOr([], ['tenant_policy_conditions'], find(propEq('name', productType), getSubProduct(products)))
  const tenantLinkOptional = equals(TRUE, pathOr(FALSE, ['tenant_policy_conditions_optional'], find(propEq('name', productType), getSubProduct(products))))
  const defaultLinkOptional = equals(TRUE, pathOr(FALSE, ['default_link_optional'], find(propEq('name', productType), getSubProduct(products))))
  const policyLinks=isNotEmpty(policyConditions) ? policyConditions : tenantPolicyConditions
  return {
    policyLinks: filterFooterLinks(policyLinks) ,
    tenantPolicy: isNotEmpty(filterFooterLinks(tenantPolicyConditions)),
    allTenantPolicy: tenantPolicyConditions,
    tenantLinkOptional,
    defaultLinkOptional
  }

}

const defaulLinks = [
  {
    name: 'Terms of Use',
    public_hbs_url: 'https://lendsmartpub.s3.us-east-2.amazonaws.com/lendsmart/terms_of_use_lendsmart.hbs',
    data: {
      pre_text: SiteSettings.generalTermsPre()
    }
  },
  {
    name: 'Privacy Policy',
    public_hbs_url: 'https://lendsmartpub.s3.us-east-2.amazonaws.com/lendsmart/lendsmart_privacy_policy.hbs',
    data: {
      pre_text: SiteSettings.generalPolicyPre(),
      pre_text_link: SiteSettings.generalPolicyLink()
    }
  }
];


//logo.svg
//must be uploaded to the namespace directory in name logo.svg
// eg: <aws location>/suttonbank/logo.svg
export const svgLogoUrl = () => {
  const logo = SiteSettings.themeWebsiteLogo()
  return returnIsNotEmptyOrTrue(logo, logo, `${s3Pub()}/logo.svg`);
};


//must be uploaded to lendsmart in name terms_of_use_lendsmart.hbs
// eg: <aws location>/lendsmart/terms_of_use_lendsmart.hbs
// eg: terms_of_use_lendsmart.hbs
export const getS3Url = (fileName: string) => {
  return `${PUB_LOCATION}/lendsmart/${fileName}`;
};


//auth_pic.svg
//must be uploaded to the namespace directory in name bot_logo.svg
// eg: <aws location>/suttonbank/bot_logo.svg
export const svgAuthPicUrl = () => {
  const authPic = SiteSettings.themeWebsiteWelcomePageLogo()
  return returnIsNotEmptyOrTrue(authPic, authPic, `${s3Pub()}/auth_pic.svg`);
};


//blank_avatar.svg
//must be uploaded to the namespace directory in name bot_logo.svg
// eg: <aws location>/suttonbank/bot_logo.svg
export const svgBlankAvatarPicUrl = () => {
  return `${s3Pub()}/blank_avatar.svg`;
};

//equal_housing_logo.svg
//must be uploaded to the namespace directory in name equal_housing_logo.svg
// eg: <aws location>/lendsmart/equal_housing_logo.svg
export const svgEqualHousingLogoUrl = () => {
  return `${DEFAULT_S3_PUB_LOCATION}/lendsmart/equal_housing_logo.svg`;
};

//fdic.svg
//must be uploaded to the namespace directory in name FDIC.svg
// eg: <aws location>/lendsmart/FDIC.svg
export const svgFDICLogoUrl = () => {
  return `${DEFAULT_S3_PUB_LOCATION}/lendsmart/FDIC.svg`;
};

export const getFooterLinks = (loanProducts: any, loanType: any, loanProductType?: string, status?: any) => {
  const productType = returnIsNotEmptyOrTrue(loanProductType, loanProductType, unAuthenticatedUser.productType.get())
  const finder = new LoanProductFinder(
    loanType,
    loanProducts
  );
  const products = finder.filterProductByLoanType();
  const {
    policyLinks = [],
    tenantPolicy,
    tenantLinkOptional,
    defaultLinkOptional,
    allTenantPolicy = [],
  } = getPolicyConditions(products, productType)
  return tenantPolicy && isEmptyOrNil(status) ? {
    tenantPolicyLinks: policyLinks,
    tenantLinkOptional,
    defaultLinkOptional,
    defaulLinks: defaulLinks,
    allTenantPolicy
  } : {
    defaulLinks: concat(policyLinks, defaulLinks),
      defaultLinkOptional,
      allTenantPolicy
  };
}

